import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ModalComponent } from 'src/app/shared/components/modal/modal.component';
import { ModalConfirmEditComponent } from '../modal-confirm-edit/modal-confirm-edit.component';
import { InsuranceService } from 'src/app/core/services/insurance.service';

@Component({
  selector: 'aig-modal-add-documentation',
  imports: [ModalComponent, CommonModule, ModalConfirmEditComponent],
  templateUrl: './modal-add-documentation.component.html',
  styleUrl: './modal-add-documentation.component.scss',
})
export class ModalAddDocumentationComponent {
  @Input() idSiniestro?: number;
  @Output() hideAddDocModal: EventEmitter<boolean> =
    new EventEmitter<boolean>();

  router: any;
  mensaje = '';

  public visibleConfirmEditModal: boolean = false;

  uploadedFiles: File[] = [];
  uploadError: string | null = null;

  constructor(private insuranceService: InsuranceService) {}

  clickHide(): void {
    this.hideAddDocModal.emit(true);
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    const files = input.files;

    if (files && files.length) {
      const filesArray = Array.from(files);
      this.uploadedFiles = [...this.uploadedFiles, ...filesArray];
    }

    // 🔑 Permite que seleccionar los mismos ficheros vuelva a disparar (change)
    input.value = '';
  }

  onDrop(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    const files = event.dataTransfer?.files;
    if (files && files.length > 0) {
      const filesArray = Array.from(files);
      this.uploadedFiles = [...this.uploadedFiles, ...filesArray];
      this.uploadError = null;
    }
  }

  onDragOver(event: DragEvent): void {
    event.preventDefault();
  }

  handleFile(file: File): void {
    // Simular error si el archivo tiene nombre 'error'
    if (file.name === 'error.pdf') {
      this.uploadError = file.name;
    } else {
      this.uploadedFiles.push(file);
      this.uploadError = null;
    }
  }

  removeFile(file: File): void {
    this.uploadedFiles = this.uploadedFiles.filter((f) => f !== file);
    if (file.name === this.uploadError) this.uploadError = null;
  }

  save() {
    //"save");
    if (!this.idSiniestro || this.uploadedFiles.length === 0) {
      this.mensaje = 'Debe seleccionar un siniestro y al menos un archivos.';
      //console.log(this.mensaje);
      return;
    }

    this.mensaje = '';

    this.insuranceService
      .adjuntarDocumentacion(this.idSiniestro, this.uploadedFiles)
      .subscribe({
        next: () => {
          this.mensaje = 'Documentos adjuntados correctamente.';
          this.uploadedFiles = [];
        },
        error: (err) => {
          console.error('Error al subir documentos:', err);
          this.mensaje = 'Error al subir documentos.';
        },
      });
    //console.log(this.mensaje);
    this.visibleConfirmEditModal = true;
  }

  CloseSaveModal() {
    this.visibleConfirmEditModal = false;
    this.hideAddDocModal.emit(true);
  }
}
